import React, { useEffect, useState } from "react";
import { Button, Grid, InlineStack, Text } from "@shopify/polaris";
import { useNavigate } from "react-router-dom";
import { GetStoreBoxOrders } from "../../services/storeBoxOrder";
import StoreBoxOrderTable from "../../components/StoreBoxes/StoreBoxesOrdersTable";
import { GetStoreBoxes } from "../../services/storeBox";
import InventoryCard from "../../components/StoreBox/InventoryCard";
import InfoCard from "../../components/Common/InfoCard";
import EmptyState from "../../components/Common/EmptyState";

const StoreBoxesDashboard = () => {
  const navigate = useNavigate();
  const [storeBoxesOrders, setStoreBoxesOrders] = useState([]);
  const [storeBoxes, setStoreBoxes] = useState({
    _id: "",
    store: "",
    inventory: [
      {
        box: {
          _id: "",
          name: "-",
          description: "-",
          sizes: {
            size: "-",
            dimensions: {
              length: "-",
              width: "-",
              height: "-",
              unit: "-",
            },
            weightLimit: "-",
          },
        },
        quantity: 0,
        used: 0,
        remaining: 0,
      },
    ],
    totalUsed: 0,
    totalRemaining: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);

  const fetchStoreBoxOrders = async () => {
    const { data } = await GetStoreBoxOrders(currentPage);
    if (data.result) {
      setStoreBoxesOrders(data.result);
    }
  };
  const fetchStoreBoxes = async () => {
    const { data } = await GetStoreBoxes();
    if (data.result && data.result?.inventory) {
      setStoreBoxes(data.result);
    }
  };

  const handleNavigate = (path) => {
    navigate(path);
  };
  useEffect(() => {
    fetchStoreBoxOrders();
    fetchStoreBoxes();
  }, [currentPage]);

  return (
    <>
      {!storeBoxesOrders.length ? (
        <EmptyState
          heading={"No gift box found"}
          text={"Order gift boxes to package your customer's gifts."}
          btnName={"Order boxes"}
          redirect={"/store-box-order/create"}
          img="no boxes found.svg"
        />
      ) : (
        <>
          {storeBoxes && storeBoxes?.inventory?.length && (
            <Grid>
              <InventoryCard inventory={storeBoxes?.inventory} />
              <InfoCard
                columnSpan={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}
                label={"Remaining"}
                value={storeBoxes.totalRemaining}
              />
              <InfoCard
                columnSpan={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}
                label={"Used"}
                value={storeBoxes.totalUsed}
              />
            </Grid>
          )}
          <br />
          <InlineStack align="space-between">
            <Text variant="headingLg">Box orders</Text>
            <Button
              onClick={() => {
                handleNavigate("/store-box-order/create");
              }}
              variant="primary"
            >
              Create Order
            </Button>
          </InlineStack>
          <br />
          {storeBoxesOrders.length && (
            <StoreBoxOrderTable
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              storeBoxOrders={storeBoxesOrders}
            />
          )}
        </>
      )}
    </>
  );
};

export default StoreBoxesDashboard;

// const test =
